import React from 'react';
import './ToolSlide.css';
import { directDeepLink, SOURCE_HOME,SOURCE_WEBVIEW } from '../../../util';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {
	create_and_share_poster,
	Tips_from_experts,
	create_polls,
	send_notification
} from '../../../../../cosmosTracking/cosmosEvents';
import toolsAnimation from '../../../Resources/Slides/indipendence/tools-boost.json';
import Lottie from "react-lottie";

function ToolSlide(props) {
	const { data } = props;
	const toolsAnimationLottie = {
		loop: true,
		autoplay: true,
		animationData: toolsAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};
	const handleClick = (tool,index) => {
		if (index === 0) {
			cosmosTrackService(create_and_share_poster);
			directDeepLink(tool?.deeplink, SOURCE_HOME);
		} else if (index === 1) {
			cosmosTrackService(create_polls);
			directDeepLink(tool?.deeplink, SOURCE_HOME);
		} else if (index === 2) {
			cosmosTrackService(Tips_from_experts);
			directDeepLink(tool?.deeplink, SOURCE_HOME,SOURCE_WEBVIEW );
		} else if (index === 3) {
			cosmosTrackService(send_notification);
			directDeepLink(tool?.deeplink, SOURCE_HOME ,SOURCE_WEBVIEW );
		}
	}
	return (
		<>
			<div className="slideCard slideCardTools">
				<div className="cardHeader">
					<Lottie options={toolsAnimationLottie} height={128}></Lottie>
				</div>
				<div className="cardContent">
					<div className="toolGroup">
						{data.slice(0, 4)?.map((tool, index) => (
							<div className="toolBtn" onClick={()=>handleClick(tool,index)} key={index}>
								{index === 0 && <img src='https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-tool-create.png' width={24}/>}
								{index === 1 && <img src='https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-tool-video.png' width={24}/>}
								{index === 2 && <img src='https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-tool-user.png' width={24}/>}
								{index === 3 && <img src='https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-tool-book.png' width={24}/>}
								{tool?.text}
								<img src='https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/15-aug-tool-next.png' width={20}/>
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	);
}
export default ToolSlide;
